import CollapseButton from './CollapseButton.vue'

export default CollapseButton
